import React from "react";
import ctfLogo from "../../../assets/images/ctf_logo.svg";
import { Col, Row } from "reactstrap";
import { SocialIcon } from "react-social-icons";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import phoneIcon from "../../../assets/images/phone.svg";
import mail from "../../../assets/images/mail.svg";
import visa from "../../../assets/images/visa.svg";
import masterCard from "../../../assets/images/master-card.svg";

const linkStyles = {
  textDecoration: "none",
  fontFamily: "Montserrat",
  fontWeight: "600",
  fontSize: "14px",
  lineHeight: "21px",
  color: "#4D4467",
  display: "inline",
};

const ulStyle = {
  display: "flex",
  justifyContent: "space-between",
};

const infoStyle = {
  color: "#0F172A",
  fontWeight: "500",
  fontSize: "14px",
};

const infoIconStyle = { marginRight: "10px" };

const smallStyles = {
  color: "#647488",
  fontFamily: "Montserrat",
  fontSize: "14px",
};

const scoialBgColor = "#F1F5F9";
const scoialfgColor = "#4D4467";

const NewFooter = ({ socialMedia }) => {
  return (
    <Row
      className="new-footer-container"
      xs={12}
      style={{ justifyContent: "space-around", marginTop: "20%" }}
    >
      <Row
        className="new-footer-inner-container"
        xs={12}
        style={{ justifyContent: "space-around" }}
      >
        <Row
          className="new-footer-upper-row"
          xs={12}
          style={{ width: "65vw", marginBottom: "51px" }}
        >
          <Col sm={12} lg={6} style={{ display: "flex", alignItems: "center" }}>
            <img className="new-footer-logo" src={ctfLogo} alt="logo" />
          </Col>
          <Col
            className="new-footer-upper-ul-container"
            sm={12}
            lg={6}
            style={{ display: "flex", justifyContent: "end" }}
          >
            <ul
              className="new-footer-upper-ul"
              style={{ ...ulStyle, width: "70%" }}
            >
              <Link to="/contact-us" style={linkStyles}>
                <li>{i18n.t("contact-us")}</li>
              </Link>
              <Link to="privacy-policy" style={linkStyles}>
                <li>{i18n.t("privacy-policy")}</li>
              </Link>
              <Link to="terms" style={linkStyles}>
                <li>{i18n.t("terms_of_use")}</li>
              </Link>
            </ul>
          </Col>
        </Row>
        <Row
          className="new-footer-lower-row"
          xs={12}
          style={{
            width: "65vw",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Col className="new-footer-lower-ul-container" sm={12} lg={6}>
            <ul
              className="new-footer-lower-ul"
              style={{ ...ulStyle, width: "100%" }}
            >
              <li>
                <img src={phoneIcon} style={infoIconStyle} alt="phone" />
                <small style={infoStyle}>+962 79 1000 446</small>
              </li>
              <li>
                <img src={mail} style={infoIconStyle} alt="mail" />
                <small style={infoStyle}>team@connecttofit.com</small>
              </li>
            </ul>
          </Col>
          <Col
            className="new-footer-social-ul-container"
            sm={12}
            lg={6}
            style={{ display: "flex", justifyContent: "right" }}
          >
            <ul style={{ ...ulStyle, width: "50%" }}>
              <li>
                <SocialIcon
                  bgColor={scoialBgColor}
                  fgColor={scoialfgColor}
                  url={`${socialMedia && socialMedia.facebook}`}
                />
              </li>
              <li>
                <SocialIcon
                  bgColor={scoialBgColor}
                  fgColor={scoialfgColor}
                  url={`${socialMedia && socialMedia.instagram}`}
                />
              </li>
              <li>
                <SocialIcon
                  bgColor={scoialBgColor}
                  fgColor={scoialfgColor}
                  url={`${socialMedia && socialMedia.twitter}`}
                />
              </li>
              <li>
                <SocialIcon
                  bgColor={scoialBgColor}
                  fgColor={scoialfgColor}
                  url={`${socialMedia && socialMedia.linkedin}`}
                />
              </li>
            </ul>
          </Col>
        </Row>
      </Row>
      <hr
        style={{
          background: "#E2E8F0",
          color: "#E2E8F0",
          borderColor: "#E2E8F0",
          height: "1px",
          width: "65vw",
        }}
      />
      <Row
        style={{
          width: "65vw",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
        className={"new-copyrights"}
      >
        <Col
          xs={12}
          sm={6}
          style={{ display: "flex", justifyContent: "start" }}
        >
          <small style={smallStyles}>
            {i18n.t("rights", { year: new Date().getFullYear() })}
          </small>
        </Col>
        <Col
          xs={12}
          sm={6}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
          className="new-footer-verified-container"
        >
          <small style={{ ...smallStyles, marginRight: "16px" }}>
            {i18n.t("verified_by")}
          </small>
          <img src={masterCard} />
          <img src={visa} style={{ width: "40px", height: "40px" }} />
        </Col>
      </Row>
    </Row>
  );
};

const mapStateToProps = (state) => {
  const { socialMedia } = state.socialMedia;
  return { socialMedia };
};

export default connect(mapStateToProps)(withNamespaces()(NewFooter));
